/**
 * Lectura tolerante de los documentos de KYC del usuario.
 *
 * POR QUÉ HACE FALTA ESTO
 * `kyc-documents.tsx` guardaba las fotos con una clave con punto —
 * `{ 'kycDocs.1_frente_del_vehiculo': {...} }` — creyendo que Firestore la
 * interpretaría como ruta. Pero eso solo pasa con `update()`; con
 * `set({ merge: true })`, que es lo que usa `updateUserProfile`, el punto es
 * parte del NOMBRE del campo. Resultado: documentos con campos sueltos
 * llamados literalmente "kycDocs.1_frente_del_vehiculo", y ningún mapa
 * `kycDocs`.
 *
 * Todo el que leía `user.kycDocs` quedaba ciego:
 *   · la tarjeta "Mi vehículo" del perfil,
 *   · y —más grave— el chequeo del Papel de Buena Conducta que decide si un
 *     chofer puede ponerse en línea (map.tsx) y el de school-driver-setup.
 *
 * La escritura ya está corregida, pero los documentos VIEJOS siguen con la
 * forma mala. Esta función lee las dos y devuelve siempre un mapa normal, así
 * que no hace falta migrar nada para que la app funcione hoy.
 */
export function leerKycDocs(perfil: any): Record<string, any> {
  const salida: Record<string, any> = {};
  if (!perfil || typeof perfil !== 'object') return salida;

  // Forma NUEVA (correcta): un mapa anidado.
  const mapa = perfil.kycDocs;
  if (mapa && typeof mapa === 'object' && !Array.isArray(mapa)) {
    for (const [k, v] of Object.entries(mapa)) salida[k] = v;
  }

  // Forma VIEJA: campos de primer nivel cuyo nombre empieza por "kycDocs.".
  for (const [k, v] of Object.entries(perfil)) {
    if (k.startsWith('kycDocs.')) {
      const clave = k.slice('kycDocs.'.length);
      // La forma nueva manda si ambas existen.
      if (!(clave in salida)) salida[clave] = v;
    }
  }

  return salida;
}

/** URL de descarga de un documento, tolerando string suelto u objeto {url}. */
export function urlDeDocumento(doc: any): string | null {
  if (!doc) return null;
  if (typeof doc === 'string') return doc.startsWith('http') ? doc : null;
  const u = doc.url;
  return typeof u === 'string' && u.startsWith('http') ? u : null;
}
